import { render, staticRenderFns } from "./FolderInfo.vue?vue&type=template&id=381f26e4&scoped=true&"
import script from "./FolderInfo.vue?vue&type=script&lang=js&"
export * from "./FolderInfo.vue?vue&type=script&lang=js&"
import style0 from "./FolderInfo.vue?vue&type=style&index=0&id=381f26e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381f26e4",
  null
  
)

export default component.exports